import { render, staticRenderFns } from "./UpLoadImage.vue?vue&type=template&id=b587e998&scoped=true&"
import script from "./UpLoadImage.vue?vue&type=script&lang=js&"
export * from "./UpLoadImage.vue?vue&type=script&lang=js&"
import style0 from "./UpLoadImage.vue?vue&type=style&index=0&id=b587e998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b587e998",
  null
  
)

export default component.exports